export type UserLevel = 'FREE' | 'STANDARD' | 'PROFESSIONAL'

export interface LevelMeta {
  label: string
  color: string
  bg: string
  border: string
  accentBg: string
}

export interface LevelQuota {
  monthlyFee: string
  monthlyFeeNum: number
  conversionGib: number
  storageGib: number
  streamingGib: number
  download: string
  description: string
}

export const LEVEL_META: Record<UserLevel, LevelMeta> = {
  FREE:         { label: '무료',         color: 'text-emerald-300', bg: 'bg-emerald-800', border: 'border-emerald-500', accentBg: 'bg-emerald-900/40' },
  STANDARD:     { label: 'Standard',    color: 'text-blue-300',    bg: 'bg-blue-800',    border: 'border-blue-500',    accentBg: 'bg-blue-900/40' },
  PROFESSIONAL: { label: 'Professional', color: 'text-purple-300',  bg: 'bg-purple-800',  border: 'border-purple-500',  accentBg: 'bg-purple-900/40' },
}

export const LEVEL_QUOTA: Record<UserLevel, LevelQuota> = {
  FREE:         { monthlyFee: '무료',        monthlyFeeNum: 0,      conversionGib: 5,   storageGib: 5,   streamingGib: 15,   download: '미제공', description: '소규모 프로젝트에 적합합니다.' },
  STANDARD:     { monthlyFee: '99,000원/월',  monthlyFeeNum: 99000,  conversionGib: 50,  storageGib: 100, streamingGib: 200,  download: '종량제', description: '중소 규모 팀에 최적화되어 있습니다.' },
  PROFESSIONAL: { monthlyFee: '590,000원/월', monthlyFeeNum: 590000, conversionGib: 200, storageGib: 500, streamingGib: 1000, download: '종량제', description: '대용량 상용 서비스를 위한 플랜입니다.' },
}

export const LEVEL_ORDER: UserLevel[] = ['FREE', 'STANDARD', 'PROFESSIONAL']
